'use client'

import { createContext, type ReactNode, useContext, useState } from 'react'

interface AccordionItemData {
  id: Number
  accordionHeading: string
  accordionType: string
  accordionContent: string
  accordionImage: any
}

interface StepCardItemData {
  id: Number
  stepCardInfo: string
  stepIconText: string
  stepCardImage: any
}
interface ProductContextType {
  AccordianItem: AccordionItemData
  setAccordianItem: (item: AccordionItemData) => void
  stepCardItem: StepCardItemData
  setStepCardItem: (item: StepCardItemData) => void
}

const ProductContext = createContext<ProductContextType | undefined>(undefined)

interface ProductProviderProps {
  children: ReactNode
}

export const ProductProvider: React.FC<ProductProviderProps> = ({ children }) => {
  const [AccordianItem, setAccordianItem] = useState<any>({})
  const [stepCardItem, setStepCardItem] = useState<any>({})

  const contextValue: ProductContextType = {
    AccordianItem,
    setAccordianItem,
    stepCardItem,
    setStepCardItem,
  }

  return <ProductContext.Provider value={contextValue}>{children}</ProductContext.Provider>
}

export const useProductContext = () => {
  const context = useContext(ProductContext)
  if (!context) {
    throw new Error('useProductContext must be used within a ProductProvider')
  }
  return context
}
